/* eslint-disable graphql/template-strings */
import { gql } from '@apollo/client';
// Fragments
import { HostFields, HostPublicFields, StreamOverlayFields } from './fragments';

export const ON_UPDATED_STREAM = gql`
  subscription OnUpdatedStream($id: ID) {
    onUpdatedStream(id: $id) {
      id
      slug
      ...StreamOverlayFields
    }
  }
  ${StreamOverlayFields}
`;

export const ON_UPDATED_STREAM_STATUS = gql`
  subscription OnUpdatedStreamStatus($slug: String) {
    onUpdatedStreamStatus(slug: $slug) {
      id
      streamStatus
    }
  }
`;

export const ON_CHANGED_STREAM_MODE = gql`
  subscription OnChangedStreamMode($slug: String) {
    onChangedStreamMode(slug: $slug) {
      id
      mode
      rtmpPlaybackUrl
    }
  }
`;

export const ON_NOTIFY_STREAMER_HOSTS_CHANGED = gql`
  subscription OnNotifyStreamerHostsChanged($streamId: ID!) {
    onNotifyStreamerHostsChanged(streamId: $streamId) {
      streamId
      hosts {
        ...HostFields
      }
    }
  }
  ${HostFields}
`;

export const ON_NOTIFY_WATCHER_HOSTS_CHANGED = gql`
  subscription OnNotifyWatcherHostsChanged($streamId: ID!) {
    onNotifyWatcherHostsChanged(streamId: $streamId) {
      streamId
      hosts {
        ...HostPublicFields
      }
    }
  }
  ${HostPublicFields}
`;

export const ON_NOTIFY_STREAM_DESTINATION_STATUS_CHANGED = gql`
  subscription OnNotifyStreamDestinationStatusChanged($streamId: ID!) {
    onNotifyStreamDestinationStatusChanged(streamId: $streamId) {
      streamId
      converterId
      status
    }
  }
`;
